import React, { createContext, useContext, useEffect, useState } from "react";
import { adminApi, formatApiError } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = signed out, obj = signed in
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    let ignore = false;
    (async () => {
      try {
        const r = await adminApi.get("/auth/me");
        if (!ignore) setUser(r.data.user);
      } catch (e) {
        if (!ignore) setUser(false);
      } finally {
        if (!ignore) setChecking(false);
      }
    })();
    return () => { ignore = true; };
  }, []);

  const login = async (email, password) => {
    try {
      const r = await adminApi.post("/auth/login", { email, password });
      setUser(r.data.user);
      return { ok: true };
    } catch (e) {
      return { ok: false, error: formatApiError(e.response?.data?.detail) || e.message };
    }
  };

  const logout = async () => {
    try {
      await adminApi.post("/auth/logout");
    } catch {}
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, checking, login, logout, setUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const c = useContext(AuthContext);
  if (!c) throw new Error("useAuth outside provider");
  return c;
}
